import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import GlobalStyles from './globalStyles';
import App from '@containers/app';
import { store } from './reduxStore';
import { Provider } from 'react-redux';
import { inject } from '@vercel/analytics';

const DARK_COLOR_PALETTE = {
    PRIMARY_BG_COLOR: '#0b0c10',
    PRIMARY_FONT_COLOR: '#ffffff',
    CARD_BACKGROUND_COLOR: 'rgba(255, 255, 255, 0.03)',
    CARD_BORDER_COLOR: 'rgba(255, 255, 255, 0.1)',
    MODAL_BACKGROUND_COLOR: 'rgba(11, 12, 16, 0.95)',
    BLOB_COLOR_1: 'rgba(123, 31, 162, 0.8)',
    BLOB_COLOR_2: 'rgba(0, 188, 212, 0.6)',
    BLOB_COLOR_3: 'rgba(255, 64, 129, 0.5)',
    OVERLAY_COLOR: 'rgba(0, 0, 0, 0.4)',
};

const LIGHT_COLOR_PALETTE = {
    PRIMARY_BG_COLOR: '#e3e4e9',
    PRIMARY_FONT_COLOR: '#1a1a1a',
    CARD_BACKGROUND_COLOR: 'rgba(255, 255, 255, 0.35)',
    CARD_BORDER_COLOR: 'rgba(255, 255, 255, 0.45)',
    MODAL_BACKGROUND_COLOR: 'rgba(227, 228, 233, 0.95)',
    BLOB_COLOR_1: 'rgba(162, 123, 255, 0.35)',
    BLOB_COLOR_2: 'rgba(0, 212, 255, 0.25)',
    BLOB_COLOR_3: 'rgba(255, 129, 202, 0.25)',
    OVERLAY_COLOR: 'rgba(255, 255, 255, 0.2)',
};

export const ThemeContext = React.createContext({});
export const ThemeDispatchContext = React.createContext(
    () => {}
);

const Root = () => {
    const [isDarkMode, setDarkMode] = useState(() => {
        const savedTheme = localStorage.getItem('theme');
        return savedTheme ? savedTheme === 'dark' : true;
    });
    const [palette, setPalette] = useState(
        isDarkMode
            ? DARK_COLOR_PALETTE
            : LIGHT_COLOR_PALETTE
    );

    useEffect(() => {
        if (isDarkMode) {
            setPalette(DARK_COLOR_PALETTE);
            localStorage.setItem('theme', 'dark');
        } else {
            setPalette(LIGHT_COLOR_PALETTE);
            localStorage.setItem('theme', 'light');
        }
    }, [isDarkMode]);

    return (
        <React.StrictMode>
            <Provider store={store}>
                <GlobalStyles {...palette} />
                <ThemeDispatchContext.Provider
                    value={setDarkMode}
                >
                    <ThemeContext.Provider
                        value={{
                            ...palette,
                            isDarkMode,
                        }}
                    >
                        <App />
                    </ThemeContext.Provider>
                </ThemeDispatchContext.Provider>
            </Provider>
        </React.StrictMode>
    );
};

ReactDOM.render(<Root />, document.getElementById('root'));
inject();
